'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ShopifySection2 = require('./../../sections/ShopifySection');

var _ShopifySection3 = require('./../ShopifySection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = '[data-recent-searches]'; /*
                                                    *  Recent Searches
                                                    *
                                                    *
                                                    *  Version:
                                                    *    1.0.0 - 2020/07/21
                                                    */

var MORE_SELECTOR = '[data-recent-searches-more]';
var SEARCH_SELECTOR = '[data-recent-searches-search]';

var RecentSearches = function (_ShopifySection) {
  (0, _inherits3.default)(RecentSearches, _ShopifySection);

  function RecentSearches(container) {
    (0, _classCallCheck3.default)(this, RecentSearches);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RecentSearches.__proto__ || Object.getPrototypeOf(RecentSearches)).call(this, container));

    _this.searches = container.find(SEARCH_SELECTOR);

    // this.mobileLimit = 3;

    container.on('click touchend', MORE_SELECTOR, function (e) {
      return _this.showMore(e);
    });
    return _this;
  }

  (0, _createClass3.default)(RecentSearches, [{
    key: 'showMore',
    value: function showMore(e) {
      e.preventDefault(), e.stopPropagation();
      var self = (0, _jquery2.default)(e.currentTarget);

      this.searches.each(function (i, search) {
        // if (i < this.mobileLimit) return;
        if ((0, _jquery2.default)(search).hasClass('is-hidden')) return (0, _jquery2.default)(search).removeClass('is-hidden');
        // $(search).addClass('is-hidden');
      });

      self.addClass('is-hidden');
    }
  }]);
  return RecentSearches;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection3.register)(CONTAINER_SELECTOR, RecentSearches);